import {
  Button,
  TableBodyContainer,
  TableBodyLine,
  TableContainer,
  TableHeader,
  Input,
  Text1,
} from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useRootStore } from '../../../mobx-stores/store-provider'
import styles from './allowed-sso-emails-table.module.scss'

const AllowedSsoEmailsPageComponent: React.FC = () => {
  const {
    allowedSsoEmailsStore: {
      list,
      loading,
      loadAllowedEmails,
      addEmail,
      removeEmail,
    },
  } = useRootStore()

  const [newEmail, setNewEmail] = useState('')

  useEffect(() => {
    loadAllowedEmails()
  }, [loadAllowedEmails])

  const handleAdd = async () => {
    const trimmed = newEmail.trim()
    if (!trimmed) return
    await addEmail(trimmed)
    setNewEmail('')
  }

  return (
    <div className={styles.section}>
      <h3>Allowed SSO Emails</h3>
      <p className={styles.description}>
        Only these email addresses can sign in to the admin panel via SSO (Google/Microsoft).
        Add emails below to allow new users to register or sign in with SSO.
      </p>
      <div className={styles.addRow}>
        <Input
          type="email"
          placeholder="Enter email address"
          value={newEmail}
          onChange={(value) => setNewEmail(value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
        />
        <Button preset="primary" onClick={handleAdd} disabled={loading || !newEmail.trim()}>
          Add email
        </Button>
      </div>
      <TableContainer className={styles.tableWrapper}>
        <TableHeader
          tableColumns={[
            { label: 'Email', className: styles.emailColumn },
            { label: 'Actions', className: styles.actionsColumn },
          ]}
        />
        <TableBodyContainer className={styles.tableWrapper}>
          {list.length === 0 && !loading && (
            <TableBodyLine
              className={styles.tableWrapper}
              cells={[
                {
                  children: <Text1>No allowed SSO emails yet. Add one above.</Text1>,
                  className: styles.emailColumn,
                },
                { children: null, className: styles.actionsColumn },
              ]}
            />
          )}
          {list.map((item) => (
            <TableBodyLine
              key={item.id}
              className={styles.tableWrapper}
              cells={[
                {
                  children: <Text1>{item.email}</Text1>,
                  className: styles.emailColumn,
                },
                {
                  children: (
                    <Button
                      preset="secondary"
                      onClick={() => removeEmail(item.email)}
                      disabled={loading}
                    >
                      Remove
                    </Button>
                  ),
                  className: styles.actionsColumn,
                },
              ]}
            />
          ))}
        </TableBodyContainer>
      </TableContainer>
    </div>
  )
}

const AllowedSsoEmailsPage = observer(AllowedSsoEmailsPageComponent)
export {AllowedSsoEmailsPage};
